var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    borders = _ref.borders;
  return {
    editStemColor: colors.contrasts.grey100100,
    editStemFontFamily: typography.fontFamily,
    editStemFontSize: typography.fontSizeMedium,
    editStemFontWeight: typography.fontWeighNormal,
    editStemLineHeight: typography.lineHeightDouble,
    tableColor: colors.contrasts.grey4570,
    highlightBorder: borders.widthSmall,
    highlightColor: colors.contrasts.grey4570,
    highlightBorderRadius: borders.radiusMedium,
    highlightPadding: spacing.xxSmall,
    highlightMargin: spacing.xxxSmall,
    closeIconBackgroundColor: colors.contrasts.white1010
  };
};
export default generateComponentTheme;